<template lang="pug">
b-modal#editProfile(
  ref="editProfile"
  :title="$t('ui.edit_profile')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      .form-control.form-control-sm.mb-3.disabled {{ accountId }}
    b-form-group(:label="$t('ui.full_name')").mb-0
      DebounceInput(
        size="sm"
        ref="full_name"
        required
        type="text"
        :dirty="$v.full_name.$dirty"
        :error="$v.full_name.$error"
        v-model.trim.lazy="$v.full_name.$model"
        :disabled="loading"
        @focus.native="$event.target.select()"
      )
      ValidateResult(:value="$v.full_name" :name="$t('ui.full_name')")
    b-form-group(:label="$t('ui.contact_phone')").mb-0
      DebounceInput(
        size="sm"
        numeric
        type="text"
        :placeholder="$t('message.phoneFormat')"
        :dirty="$v.contact_phone.$dirty"
        :error="$v.contact_phone.$error"
        v-model.trim.lazy="$v.contact_phone.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.contact_phone" :name="$t('ui.contact_phone')")
    b-form-group(:label="$t('ui.contact_email')").mb-0
      DebounceInput(
        size="sm"
        email
        type="text"
        :dirty="$v.contact_email.$dirty"
        :error="$v.contact_email.$error"
        v-model.trim.lazy="$v.contact_email.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.contact_email" :name="$t('ui.contact_email')")
    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

import xhr from "@/plugins/xhr.js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      isMember: false,
      item: {},
      accountId: "",
      full_name: "",
      contact_phone: "",
      contact_email: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true
      }
    };
  },
  computed: {},
  validations: {
    full_name: {
      alphaNumWithSpace
    },
    contact_phone: {
      required,
      integer,
      minLength: minLength(11),
      maxLength: maxLength(11)
    },
    contact_email: {
      email,
      minLength: minLength(1),
      maxLength: maxLength(50)
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      this.submit();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.accountId = this.item.account_id;
      this.full_name = this.item.full_name;
      this.contact_phone = this.item.contact_phone;
      this.contact_email = this.item.contact_email;
      this.$refs.full_name.$el.focus();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.feedback.success = true;
        this.loading = true;
        var args = {
          session_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.username,
          target_profile_id: this.accountId,
          full_name: this.full_name,
          contact_phone: this.contact_phone,
          contact_email: this.contact_email
        };
        var endpoint = xhr.ACCOUNT.updateAccount;
        if (this.isMember == true) {
          endpoint = xhr.ACCOUNT.updateMember;
        }
        xhr
          .doRequest(args, endpoint)
          .then(res => {
            this.loading = false;
            try {
              if (res) {
                this.feedback.success = res.success;
                this.feedback.status = res.status;
                if (this.feedback.success == true) {
                  this.$refs.editProfile.hide();
                  this.$helpers.showDialog(this.$t("ui.edit_account"), this.$t("message.success"), "success");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = res.status;
            }
            this.$emit("done");
          })
          .catch(res => {
            this.loading = false;
            if (res.status.toLowerCase() == "nochanges") {
              this.$refs.editProfile.hide();
              this.$helpers.showDialog(this.$t("ui.edit_account"), this.$t("message.success"), "success");
            } else {
              this.feedback.success = false;
              this.feedback.status = res.status;
            }
            this.$emit("done");
          });
      }
    }
  }
};
</script>
